var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#d40202",
    width: "100px",
    height: "100px",
    viewBox: "-7 -1.5 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin",
    className: "jam jam-pin-alt-f",
    stroke: "#d40202",
    strokeWidth: 0.00024000000000000003,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.144
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10.465a5.002 5.002 0 0 1 1-9.9 5 5 0 0 1 1 9.9v9.1a1 1 0 0 1-2 0v-9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPin);
export default __webpack_public_path__ + "static/media/red-pin.d005228e88a250131c0cc9878d0b63ce.svg";
export { ForwardRef as ReactComponent };